import React from "react";
import { useState } from "react";
import LoginImage from "../Images/side-img.webp";
import BeatLoader from "react-spinners/BeatLoader";
/* Commenting the following code for ux.ray using AI Agent. Aug 12, 2026. Comment Start */
// import DarkLogo from "../Images/logo-blue-removebg-preview.webp";
/* Commenting end. ray using AI Agent. Aug 12, 2026 */
/* Added the following code for ux.ray using AI Agent. Aug 12, 2026. Code Start */
/* Commenting the following code for logo.ray using AI Agent. 18/08/2026. Comment Start */
// import DarkLogo from "../Pages/website/images/Logo.png";
/* Commenting end. ray using AI Agent. 18/08/2026 */
/* Added the following code for logo.ray using AI Agent. 18/08/2026. Code Start */
/* Navy/blue logo for light backgrounds; white Logo.png stays on dark chrome. */
/* Commenting the following code for logo.ray using AI Agent. 24/08/2026. Comment Start */
// import DarkLogo from "../Pages/website/images/Logo-dark.svg";
/* Commenting end. ray using AI Agent. 24/08/2026 */
/* Added the following code for logo.ray using AI Agent. 24/08/2026. Code Start */
import DarkLogo from "../Pages/website/images/Logo-dark.png";
/* Code end. ray using AI Agent. 24/08/2026 */
/* Code end. ray using AI Agent. 18/08/2026 */
/* Code end. ray using AI Agent. Aug 12, 2026 */
// import { PhoneInput } from "react-contact-number-input"; 
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import axios from "axios";
import { toast } from "react-hot-toast";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import { useEffect } from "react";
import '../index.css'; // Import your CSS file
import { BASE_URL } from "../config";
/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
import { resolveTenantBranding } from "../tenantApi";
/* Code end. ray using AI Agent. Oct 9, 2026 */

const Register = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [confirmopen, setConfirmopen] = useState(false);
  const [confirmpassword, setConfirmPassword] = useState("");
  let [loading, setLoading] = useState(false);
  /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
  const [tenantBranding, setTenantBranding] = useState(null);
  /* Code end. ray using AI Agent. Oct 9, 2026 */
  const [data, setData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    password: "",
    /* Added the following code for secure.ray using AI Agent. 23/07/2026. Code Start */
    inviteCode: "",
    /* Code end. ray using AI Agent. 23/07/2026 */
  });

  /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const inviteParam = (params.get("invite") || params.get("code") || "").trim().toUpperCase();
    const slugParam = (params.get("tenant") || params.get("slug") || "").trim().toLowerCase();
    if (inviteParam) {
      setData((prev) => ({ ...prev, inviteCode: inviteParam }));
    }
    const host = window.location.hostname;
    const isSubdomain =
      host && !["localhost", "127.0.0.1", "dev.selftrainai.com", "selftrainai.com"].includes(host);
    if (inviteParam || slugParam || isSubdomain) {
      resolveTenantBranding({
        code: inviteParam || undefined,
        slug: slugParam || undefined,
        host: isSubdomain ? host : undefined,
      })
        .then(({ status, body }) => {
          if (status === 200 && body?.success && body.data) {
            setTenantBranding(body.data);
          }
        })
        .catch(() => {});
    }
  }, [location.search]);

  const handleInviteCodeBlur = async () => {
    const code = (data.inviteCode || "").trim().toUpperCase();
    if (code.length >= 6 && (!tenantBranding || tenantBranding.inviteCode !== code)) {
      try {
        const { status, body } = await resolveTenantBranding({ code });
        if (status === 200 && body?.success && body.data) {
          setTenantBranding(body.data);
          toast.success(`Organization identified: ${body.data.name}`);
        }
      } catch {
        // silent
      }
    }
  };
  /* Code end. ray using AI Agent. Oct 9, 2026 */

  const load = () => {
    return (
      <div className={`flex justify-center items-center h-screen ${loading ? 'block' : 'hidden'}`}>
        <div className="bg-white p-5 rounded-lg">
          <BeatLoader loading={loading} className="text-cyan-900 text-3xl" />
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }
  const toggle = () => {
    setOpen(!open)
  }
  const confirmtoggle = () => {
    setConfirmopen(!confirmopen)
  }

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value })
  }
  const handlePhoneChange = (phoneNumber) => {
    setData({ ...data, phone: phoneNumber });
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target || { name: "phone", value: e }; // Use e as the value directly
  //   setData({ ...data, [name]: value });
  // };



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!data.firstname || !data.lastname || !data.email || !data.phone || !data.password || !confirmpassword) {
      toast.error("Fill all details Properly");
      return;
    }
    /* Added the following code for secure.ray using AI Agent. 23/07/2026. Code Start */
    if (!data.inviteCode) {
      toast.error("Invite code is required");
      return;
    }
    /* Code end. ray using AI Agent. 23/07/2026 */

    setLoading(true);

    if (data.password !== confirmpassword) {
      toast.error("Both passwords should be the same");
      setLoading(false);
    } else {
      //console.log(data);

      // Extract the phoneNumber from the phone object
      const phoneNumber = data.phone;

      try {
        const response = await axios.post(
          BASE_URL + "/api/user/new-register",
          { ...data, phone: phoneNumber }, // Replace phone object with phoneNumber
          {
            headers: {
              'Content-type': 'application/json',
            },
          }
        );

        //console.log(response);
        toast.success(response.data.message);

        if (response.status === 200) {
          toast.success("Redirecting to login");
          setTimeout(() => {
            /* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */
            navigate(tenantBranding?.slug ? `/login?tenant=${tenantBranding.slug}` : "/login");
            /* Code end. ray using AI Agent. Oct 9, 2026 */
          }, 2000);
        }
      } catch (err) {
        //console.log(err);
        toast.error(err.response.data.message);
      } finally {
        setLoading(false);
      }
    }
  };


  return (
    <div>
      {loading ? load() : (
        /* Added the following code for ux.ray using AI Agent. Aug 12, 2026. Code Start */
        /* Layout/branding aligned with Login for SelfTrainAI parity.
           The side image is fixed to the left half of the viewport and
           covers it (bg-cover), so it never leaves a white gap when the
           taller sign-up form scrolls. */
        <div className="relative min-h-screen">
        <div
          className="hidden bg-cover bg-center bg-no-repeat lg:fixed lg:inset-y-0 lg:left-0 lg:block lg:w-1/2"
          style={{ backgroundImage: `url(${LoginImage})` }}
          aria-hidden="true"
        />
        <div className="flex min-h-screen items-start justify-center bg-white px-4 py-6 font-sans lg:ml-[50%] lg:w-1/2 lg:items-center lg:py-8">
            <div className="w-full max-w-md overflow-hidden rounded-md bg-gray-200 p-6 py-5 shadow-lg shadow-gray-700 md:px-8">
              <div className="flex flex-col items-center text-center">
                {/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */}
                <div className="mb-2 inline-flex flex-col items-center">
                  {tenantBranding?.branding?.logoUrl ? (
                    <img
                      src={tenantBranding.branding.logoUrl}
                      alt={tenantBranding.name}
                      className="block h-12 w-auto max-w-[220px] object-contain mb-1"
                    />
                  ) : (
                    <img src={DarkLogo} alt="SelfTrainAI logo" className="block h-auto w-0 min-w-full object-contain" />
                  )}
                  <p className="mt-1 whitespace-nowrap text-sm tracking-wide text-[#044661]">
                    {tenantBranding?.branding?.title || "From Learning AI to Building AI"}
                  </p>
                </div>
                {tenantBranding && (
                  <div className="mb-2 px-3 py-1 rounded-full bg-cyan-100 text-[#044661] text-xs font-semibold inline-flex items-center gap-1.5 border border-cyan-300">
                    <span>Joining organization: <strong>{tenantBranding.name}</strong></span>
                  </div>
                )}
                <h2 className="text-2xl text-gray-500 font-semibold mb-2">
                  {tenantBranding ? `Welcome to ${tenantBranding.name}` : "Welcome to SelfTrainAI"}
                </h2>
                <p className="text-lg text-gray-500 font-semibold">Please Sign Up to your account and start</p>
                {/* Code end. ray using AI Agent. Oct 9, 2026 */}
              </div>
              <form>
                <div className="flex-col mt-7 space-y-3">
                  <div className="flex space-x-2">
                    <div className="flex-1">
                      <label className="text-gray-500 font-semibold">First Name</label>
                      <input type="text" className="border p-2 rounded w-full" name="firstname" value={data.firstname} id="firstname" onChange={handleChange} />
                    </div>
                    <div className="flex-1">
                      <label className="text-gray-500 font-semibold">Last Name</label>
                      <input type="text" className="border p-2 rounded w-full" name="lastname" id="lastname" value={data.lastname} onChange={handleChange} />
                    </div>
                  </div>
                  <div className="flex-1">
                    <label className="text-gray-500 font-semibold">Email</label>
                    <input type="email" className="w-full border p-2 rounded" name="email" id="email" value={data.email} onChange={handleChange} />
                  </div>
                  {/* Added the following code for secure.ray using AI Agent. 23/07/2026. Code Start */}
                  <div className="flex-1">
                    <label className="text-gray-500 font-semibold">Invite Code</label>
                    <input
                      type="text"
                      className="w-full border p-2 rounded uppercase"
                      name="inviteCode"
                      id="inviteCode"
                      value={data.inviteCode}
                      onChange={handleChange}
                      onBlur={handleInviteCodeBlur}
                      placeholder="e.g. ACMESCHO-1234"
                      autoComplete="off"
                    />
                    {tenantBranding && (
                      <p className="mt-1 text-xs text-cyan-700 font-medium">
                        ✓ Verified for {tenantBranding.name}
                      </p>
                    )}
                  </div>
                  {/* Code end. ray using AI Agent. 23/07/2026 */}

                  <div className="phone-input-container min-w-0 flex-1">
                    <label className="text-gray-500 font-semibold">Phone</label>
                    {/* Added the following code for ux.ray using AI Agent. Aug 12, 2026. Code Start */}
                    <PhoneInput
                      value={data.phone}
                      id="phone"
                      name="phone"
                      country={'us'}
                      onChange={handlePhoneChange}
                      containerStyle={{ width: "100%" }}
                      inputStyle={{ width: "100%" }}
                      className="form-control w-full"
                    />
                    {/* Code end. ray using AI Agent. Aug 12, 2026 */}
                  </div>
                  <div className="flex flex-col mb-4">
                    <label className="text-gray-500 font-semibold">Password</label>
                    <div className="flex items-center border rounded p-2">
                      <input type={open ? "text" : "password"} className="w-full border p-2 rounded" name="password" id="password" value={data.password} onChange={handleChange}/>
                      <div onClick={toggle} className="ml-2 text-2xl text-gray-400 cursor-pointer">
                        {open ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col mb-4">
                    <label className="text-gray-500 font-semibold">Confirm Password</label>
                    <div className="flex items-center border rounded p-2">
                      <input type={confirmopen ? "text" : "password"}  className="w-full border p-2 rounded" name="confirmpassword" id="confirmpassword" onChange={(e) => setConfirmPassword(e.target.value)}/>
                      <div onClick={confirmtoggle} className="ml-2 text-2xl text-gray-400 cursor-pointer">
                        {confirmopen ? <FaEyeSlash /> : <FaEye />}
                      </div>
                    </div>
                  </div>

                  <div className="flex flex-col">
                    <button
                      type="submit"
                      className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-2 px-4 rounded w-full"
                      onClick={handleSubmit}
                    >
                      Sign Up
                    </button>
                    <div className="text-center mt-4">
                      <span className="text-gray-500 font-semibold">Do you have an Account?</span>
                      {/* Added the following code for multitenancy_ui.ray using AI Agent. Oct 9, 2026. Code Start */}
                      <a className="font-semibold text-sky-800 ml-2" href={tenantBranding?.slug ? `/login?tenant=${tenantBranding.slug}` : "/login"}>
                        Login Now
                      </a>
                      {/* Code end. ray using AI Agent. Oct 9, 2026 */}
                      {/* Commenting the following code for ux.ray using AI Agent. Aug 12, 2026. Comment Start */}
                      {/* <a className="font-semibold text-sky-800 ml-2" href="/">Login Now</a> */}
                      {/* Commenting end. ray using AI Agent. Aug 12, 2026 */}
                    </div>
                  </div>
                </div>
              </form>
            </div>
        </div>
      </div>
      )}
    </div>

  );

}
export default Register;



